import SignIn from "./signin/SignIn";
import SignUp from "./signup/SignUp";

import ResetPassword from "./signin/ResetPassword";
import ConfirmOTP from "./verify/ConfirmOTP";

import ConfirmOTPContainer from "./verify/ConfirmOTPContainer";
import NewPasswordComponent from "./newPassword/NewPasswordComponent";

/**
 * Export all the components
 */

export {
  SignIn,
  SignUp,
  ResetPassword,
  ConfirmOTP,
  ConfirmOTPContainer,
  NewPasswordComponent
};
